var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage-mobile-preview d-flex justify-content-center align-items-center mt-4"},[_c('div',{staticClass:"stage-mobile-preview-wrapper"},[_c('div',{staticClass:"container-fluid pt-3 position-relative fh"},[_c('div',{staticClass:"mobile-main-wrap"},[_c('iframe',{attrs:{"src":_vm.currentUrl,"width":"100%","height":"100%"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }